import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Auth } from "aws-amplify";
// import Validate from './FormValidation'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import * as actionTypes from "../redux/actions";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Media,
  Col
} from "reactstrap";
import { spinnerService } from "@chevtek/react-spinners";
import { domainToUnicode } from "url";
import { DocumentClient } from "aws-sdk/clients/dynamodb";
function LoginForm(props) {
  return <h1>Hello , {props.name}</h1>;
}
function NewPWDForm(props) {
  return <h1>Hello New PWD Form, {props.name}</h1>;
}

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      _email: {
        value: "",
        isValid: true,
        err: ""
      },
      code: "",
      _code: {
        value: "",
        isValid: true,
        err: ""
      },
      password: "",
      _password: {
        value: "",
        isValid: true,
        err: ""
      },
      cpassword: "",
      _cpassword: {
        value: "",
        isValid: true,
        err: ""
      },
      screen: "forgot",
      resend: {
        msg: "",
        acitve: false
      },
      errors: {
        cognito: null,
        blankfield: false
      },
      error: true
    };
  }

  handleSubmitRequest = async e => {
    e.preventDefault();
    let { _email, email } = this.state;
    if (["", null, undefined].includes(_email.value) || !_email.isValid) {
      this.submitCheck("_email", _email.value);
      //   document.getElementById("_email").focus();
    } else {
      try {
        spinnerService.show("mySpinner");
        this.setState({ email: _email.value });
        email = _email.value;
        email = email.toLowerCase();
        await Auth.forgotPassword(email)
          .then(() => {
            this.setState({ screen: "new" });
            spinnerService.hide("mySpinner");
          })
          .catch(err => {
            if (err.code === "UserNotFoundException") {
              toast.error("No Such User");
            } else {
              toast.error(err.message);
            }
            spinnerService.hide("mySpinner");
          });
      } catch (err) {
        spinnerService.hide("mySpinner");
        this.props.storeUser("notFound");
        toast.error(err.message);
      }
    }
  };

  handleSubmitPassword = async event => {
    event.preventDefault();
    let { password, code, email, _password, _cpassword, _code } = this.state;
    if (["", null, undefined].includes(_password.value) || !_password.isValid) {
      this.submitCheck("_password", _password.value);
      //   document.getElementById("_password").focus();
    } else if (
      ["", null, undefined].includes(_cpassword.value) ||
      !_cpassword.isValid
    ) {
      this.submitCheck("_cpassword", _cpassword.value);
      //   document.getElementById("_cpassword").focus();
    } else if (["", null, undefined].includes(_code.value) || !_code.isValid) {
      this.submitCheck("_code", _code.value);
      //   document.getElementById("_code").focus();
    } else {
      try {
        (password = _password.value), (code = _code.value);
        this.setState({
          password: _password.value,
          code: _code.value
        });
        spinnerService.show("mySpinner");
        await Auth.forgotPasswordSubmit(email, code, password)
          .then(() => {
            toast.success("Password Changed");
            setTimeout(() => {
              spinnerService.hide("mySpinner");
              this.props.history.push("/");
            }, 2000);
          })
          .catch(err => {
            toast.error(err.message);
            spinnerService.hide("mySpinner");
          });
      } catch (err) {
        spinnerService.hide("mySpinner");
        this.props.storeUser("notFound");
        toast.error(err.message);
      }
    }
  };

  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  submitCheck = (id, value) => {
    if (["", null, undefined].includes(value) || value.length <= 0) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "This Field Is Required"
        }
      });
    } else if (value.length > 0) {
      if (id === "_code" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Please Enter 6 Digit Code"
          }
        });
      } else if (id === "_password" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Must be atleast 6 Characters Long"
          }
        });
      } else if (id === "_cpassword" && value !== this.state._password.value) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Didn't Match"
          }
        });
      }
    }
  };

  runtimeCheck = event => {
    const { id, value } = event.target;
    if (["", null, undefined].includes(value) || value.length <= 0) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "This Field Is Required"
        }
      });
    } else if (value.length > 0) {
      if (id === "_code" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Please Enter 6 Digit Code"
          }
        });
      } else if (id === "_password" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Must be atleast 6 Characters Long"
          }
        });
      } else if (id === "_cpassword" && value !== this.state._password.value) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Didn't Match"
          }
        });
      }
    }
  };

  _onInputChange = event => {
    const { id, value } = event.target;
    this.setState({
      [id]: {
        value,
        isValid: true,
        err: ""
      }
    });
  };

  render() {
    let { screen, resend } = this.state;
    return (
      <div style={{ paddingTop: 20 }}>
        <main ref="main">
          <ToastContainer />
          <section className="section section-shaped section-lg">
            <Container className=" pt-lg-sm pt-2">
              {screen === "forgot" ? (
                <Row className="justify-content-center">
                  <Col lg="8">
                    <Card className="bg-secondary shadow border-0">
                      <CardHeader className="bg-white pb-2 pt-3">
                        <div className="pb-2">
                          <span style={{ fontSize: "30px" }}>
                            {" "}
                            Forgot Password!{" "}
                          </span>
                        </div>
                      </CardHeader>

                      <CardBody className="bg-white  px-5 py-5">
                        <Form onSubmit={this.handleSubmitRequest} role="form">
                          <FormGroup>
                            <InputGroup className=" input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>

                              <Input
                                value={this.state._email.value}
                                id="_email"
                                onChange={this._onInputChange}
                                onBlur={this.runtimeCheck}
                                placeholder="Username"
                                type="text"
                                autoComplete="off"
                              />
                            </InputGroup>
                          </FormGroup>
                          {!this.state._email.isValid && (
                            <text
                              style={{
                                color: "red",
                                fontSize: 12,
                                marginLeft: 10
                              }}
                            >
                              {" "}
                              {this.state._email.err}
                            </text>
                          )}
                          <Row>
                            <Col xs="auto">
                              <div>
                                <Button
                                  className=""
                                  type="submit"
                                  color="primary"
                                >
                                  Send Confirmation Code
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              ) : (
                screen === "new" && (
                  <Row className="justify-content-center">
                    <Col lg="8">
                      <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-white pb-2 pt-3">
                          <div className="pb-2">
                            <span style={{ fontSize: "30px" }}>
                              {" "}
                              Set New Password!{" "}
                            </span>
                          </div>
                        </CardHeader>

                        <CardBody className="bg-white  px-5 py-5">
                          <Form
                            onSubmit={this.handleSubmitPassword}
                            role="form"
                          >
                            <FormGroup>
                              <InputGroup className=" input-group-alternative mb-3">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText></InputGroupText>
                                </InputGroupAddon>

                                <Input
                                  value={this.state._code.value}
                                  id="_code"
                                  onChange={this._onInputChange}
                                  onBlur={this.runtimeCheck}
                                  placeholder="Enter Confirmation Code"
                                  type="text"
                                  autoComplete="off"
                                />
                              </InputGroup>
                            </FormGroup>
                            {!this.state._code.isValid && (
                              <text
                                style={{
                                  color: "red",
                                  fontSize: 12,
                                  marginLeft: 10
                                }}
                              >
                                {" "}
                                {this.state._code.err}
                              </text>
                            )}
                            <FormGroup>
                              <InputGroup className=" input-group-alternative mb-3">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText></InputGroupText>
                                </InputGroupAddon>

                                <Input
                                  value={this.state._password.value}
                                  id="_password"
                                  onChange={this._onInputChange}
                                  onBlur={this.runtimeCheck}
                                  placeholder="Enter New Password"
                                  type="password"
                                  autoComplete="off"
                                />
                              </InputGroup>
                            </FormGroup>
                            {!this.state._password.isValid && (
                              <text
                                style={{
                                  color: "red",
                                  fontSize: 12,
                                  marginLeft: 10
                                }}
                              >
                                {" "}
                                {this.state._password.err}
                              </text>
                            )}
                            <FormGroup>
                              <InputGroup className=" input-group-alternative mb-3">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText></InputGroupText>
                                </InputGroupAddon>

                                <Input
                                  value={this.state._cpassword.value}
                                  id="_cpassword"
                                  onChange={this._onInputChange}
                                  onBlur={this.runtimeCheck}
                                  placeholder="Confrim Password"
                                  type="password"
                                  autoComplete="off"
                                />
                              </InputGroup>
                            </FormGroup>
                            {!this.state._cpassword.isValid && (
                              <text
                                style={{
                                  color: "red",
                                  fontSize: 12,
                                  marginLeft: 10
                                }}
                              >
                                {" "}
                                {this.state._cpassword.err}
                              </text>
                            )}
                            <Row>
                              <Col xs="auto">
                                <div>
                                  <Button
                                    className=""
                                    type="submit"
                                    color="primary"
                                  >
                                    Set New Password
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </Form>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                )
              )}
            </Container>
          </section>
        </main>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: state.config.user
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeUser: data => dispatch(actionTypes.storeUser(data)),
    storeProfile: data => dispatch(actionTypes.storeProfile(data))
  };
};
export default ForgotPassword = connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword.js